import { createFileRoute } from '@tanstack/react-router';
import { SpvSettingsScreen } from '../../../features/settings/spv-settings-screen';

/**
 * Setări → ANAF (SPV) (#200): datele aplicației ANAF, cu secretul pe drum propriu, ca SMTP-ul.
 * Conectarea fiecărei firme se face din fișa ei, tabul SPV.
 */
export const Route = createFileRoute('/_authenticated/setari/spv')({
  component: SpvSettingsScreen,
});
